import React from 'react';

export default function Top5Talents(props) {

  let { } = props;

  return (
    <>

      {/* Resources section */}

      <section className="w-full py-4 space-y-6">
        <div>
          <h1 className=" text-3xl font-semibold  text-[#3D405B]">Resources</h1>
          <h1 className=" text-xl text-[#3D405B]  ">Choose an experts according to your choice</h1>
        </div>
        <div className="grid grid-cols-1 gap-6 xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
          <div className="transition-all duration-150 rounded-xl shadow-sm hover:shadow-xl bg-white border overflow-hidden">
            <iframe className="youtube-video" src="https://www.youtube.com/embed/qchkvJ8L8rY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="1" />
            <div className="px-5 py-6 ">
              <h1 className="text-[#3D405B] font-semibold text-xl mb-1 capitalize">The Unexpected Benefits of Celebrating Failure</h1>
              <p className="text-[#3D405B]/70 tracking-wide text-base text-left py-2">Astro Teller, TED Talk</p>
            </div>
          </div>
          <div className="transition-all duration-150 rounded-xl shadow-sm hover:shadow-xl bg-white border overflow-hidden">
            <iframe className="youtube-video" src="https://www.youtube.com/embed/S2qeTfOxDF8?list=PL9H6i6Cs6lewRVfuCosTqvoU1237I9y4A" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="1" />
            <div className="px-5 py-6">
              <h1 className="text-[#3D405B] font-semibold text-xl mb-1 capitalize">The Unexpected Benefits of Celebrating Failure</h1>
              <p className="text-[#3D405B]/70 tracking-wide text-base text-left py-2">Astro Teller, TED Talk</p>
            </div>
          </div>
          <div className="transition-all duration-150 rounded-xl shadow-sm hover:shadow-xl bg-white border overflow-hidden">
            <iframe className="youtube-video" src="https://www.youtube.com/embed/3UHncbbgD-c?list=PL9H6i6Cs6lewRVfuCosTqvoU1237I9y4A" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="1" />
            <div className="px-5 py-6">
              <h1 className="text-[#3D405B] font-semibold text-xl mb-1 capitalize">The Unexpected Benefits of Celebrating Failure</h1>
              <p className="text-[#3D405B]/70 tracking-wide text-base text-left py-2">Astro Teller, TED Talk</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
